module.exports = __webpack_public_path__ + "img/Ostreococcus_lucimarinus.0bd896df.jpg";